import { render, staticRenderFns } from "./MobileInventoryValuation.vue?vue&type=template&id=3d28a5da&scoped=true"
import script from "./MobileInventoryValuation.vue?vue&type=script&lang=js"
export * from "./MobileInventoryValuation.vue?vue&type=script&lang=js"
import style0 from "./MobileInventoryValuation.vue?vue&type=style&index=0&id=3d28a5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28a5da",
  null
  
)

export default component.exports